import { Button } from "@mui/material";
import AppsIcon from "@mui/icons-material/Apps";
import { useDispatch } from "react-redux";
import { setSidebarOpen, useSettingsSelector } from "../../../store/global/settingsSlice";

function RootMenu() {
    const {
        sidebar: { open },
    } = useSettingsSelector();
    const dispatch = useDispatch();
    const handleSidebarToggle = () => dispatch(setSidebarOpen(!open));

    return (
        <Button onClick={handleSidebarToggle}>
            <AppsIcon />
        </Button>
    );
}

export default RootMenu;
